// extracted by mini-css-extract-plugin
export default {"introduction":"Preloader_introduction__VSCy7"};